import React, { Component } from 'react';
import * as _ from 'lodash';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { HEADER_CONSTANTS } from '../utilities/constants';
import dialogLoader from '../utilities/dialogLoader';
import Helmet from 'react-helmet';
import { MasterPageHeader } from '../components/PageHeader';
import { FormInformationDialog } from '../components/FormInformationDialog';
import {
  FormElement,
  FormList,
  FormListItem,
} from '../components/CommonFormComponents';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';
import userNoticeSettingsService from '../services/UserNoticeSettings';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';

/**
 * @description アカウント " 詳細 " 画面
 */
export class UserProfileNotify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user_id: localStorage.getItem('user_id'),
      params: {},
    };
  }

  UNSAFE_componentWillMount() {
    this.onLoad();
  }

  //https://v2-dev.buildee.jp/apidocs/public/user_notice_settings/list.html
  ///api/private/user_notice_settings/list
  async onLoad() {
    const data = await userNoticeSettingsService.list();
    if (data.result) {
      const _data = _.cloneDeep(data.data.entities.user_notice_settings);
      const settings = _.sortBy(_data, v => {
        return v.message_type_group_code;
      });
      this.setState({ settings });
    }
  }

  onChange = (index, name, value) => {
    const settings = _.cloneDeep(this.state.settings);
    settings[index].notice_flag = parseInt(value);
    this.setState({ settings });
  };

  //https://v2-dev.buildee.jp/apidocs/public/user_notice_settings/create.html
  ///api/private/user_notice_settings
  submit() {
    const updateInfo = {
      user_notice_settings: _.cloneDeep(this.state.settings),
    };
    userNoticeSettingsService
      .submit(updateInfo)
      .then(data => {
        if (data.result) {
          dialogLoader.show(FormInformationDialog, {
            onClose: () => {
              dialogLoader.close();
            },
            title: '通知設定更新完了',
            message: '通知設定の更新が完了しました。',
          });
        }
      })
      .catch(e => {
        alert(e[0].responseJSON.message);
      });
  }

  settingItem() {
    return _.map(this.state.settings, (item, index) => {
      return (
        <FormListItem label={item.name} key={index}>
          <FormElement>
            <div className='form-list-radio'>
              <div className='form-list-radio__item'>
                <RadioButton
                  index={index}
                  name={item.message_type_group_code}
                  label='ON'
                  value='1'
                  onClick={this.onChange}
                  checked={item.notice_flag}
                />
              </div>
              <div className='form-list-radio__item'>
                <RadioButton
                  index={index}
                  name={item.message_type_group_code}
                  label='OFF'
                  value='0'
                  onClick={this.onChange}
                  checked={!item.notice_flag}
                />
              </div>
            </div>
          </FormElement>
        </FormListItem>
      );
    });
  }

  render() {
    const { params } = this.state;

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - アカウント詳細・編集</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={'アカウント詳細・編集'}
            onClose={() => _masterSlideLoader.close()}
          />

          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <SideMenu
                company_name={params.company ? params.company.name : ''}
                roleId={this.roleId}
              />

              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <BackLinkButton />
                <FormViewMenu submit={this.submit.bind(this)} />
                <div className='contruction-detail-view__bar' />

                {/* ここからフォーム */}
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
                  <FormList>{this.settingItem()}</FormList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const RadioButton = ({ index, name, label, value, onClick, checked }) => {
  return (
    <label className='radio'>
      <input
        type='radio'
        name={name}
        onChange={() => {
          onClick(index, name, value);
        }}
        value={value}
        checked={checked}
      />
      <RadioButtonIcon className='icon--2x' />
      <span>{label}</span>
    </label>
  );
};

const SideMenu = ({ company_name, roleId }) => (
  <div className='contruction-detail-view__sidemenu'>
    <ul className='contruction-navi-list'>
      <li className='contruction-navi-list__item'>
        <div
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            _masterSlideLoader.show('UserProfileDetail', { state: {} });
          }}
        >
          基本情報
        </div>
      </li>
      {isPrimaryCompanyRoleId(roleId) && (
        <li className='contruction-navi-list__item'>
          <a
            className='line-list line-list--contruction-navi-list'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              _masterSlideLoader.show('UserProfilePhoto', { state: {} });
            }}
          >
            顔写真
          </a>
        </li>
      )}
      <li className='contruction-navi-list__item'>
        <div className='line-list line-list--contruction-navi-list select'>
          通知設定
        </div>
      </li>
      <li className='contruction-navi-list__item'>
        <div
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            _masterSlideLoader.show('UserProfileSettingMail', { state: {} });
          }}
        >
          メール受信設定
        </div>
      </li>
      <li className='contruction-navi-list__item' style={{ display: 'none' }}>
        <div className='line-list line-list--contruction-navi-list'>
          労務安全項目
        </div>
      </li>
      <li className='contruction-navi-list__item' style={{ display: 'none' }}>
        <div className='line-list line-list--contruction-navi-list'>
          {`${company_name || '名無し'} 独自項目`}
        </div>
      </li>
    </ul>
  </div>
);

const BackLinkButton = () => (
  <div className='contruction-detail-view__header'>
    <button className='btn-text--sm' onClick={() => _masterSlideLoader.close()}>
      <i className='i-back--blue i-2x vertical-middle' />
      閉じる
    </button>
  </div>
);

// イベントを受け取るのでここは React.Component にする
class FormViewMenu extends React.Component {
  render() {
    return (
      <div className='contruction-detail-view__menu'>
        <span className='construction-detail-view__button'>
          <button
            className='btn--effective'
            onClick={() => this.props.submit()}
          >
            更新
          </button>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/UserProfileNotify.jsx